import lf from 'lovefield'

export function simu_etudes_exo_cubatures_exo_mouvements (schemaBuilder) {
  schemaBuilder.createTable('simu_etudes_exo_cubatures_exo_mouvements')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('exo_cubatures_id', lf.Type.INTEGER)
      .addColumn('exo_mouvements_id', lf.Type.INTEGER)
      .addColumn('rendement', lf.Type.NUMBER)
      .addColumn('cout', lf.Type.NUMBER)
      .addPrimaryKey(['id']);
}

/*
CREATE TABLE IF NOT EXISTS `simu-etudes_exo-cubatures_exo-mouvements` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `exo-cubatures_id` int(11) NOT NULL,
  `exo-mouvements_id` int(11) NOT NULL,
  `rendement` float NOT NULL,
  `cout` float NOT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEtudes_exoCubatures_exoMouvements.schema.js